export default {
  webCategory1: [],
  webCategory2: [],
  webCategory3: [],
  webCategory4: [],
};
